import React, {Component} from 'react';
import Const from './Const'
import './App.css'
import Top from './topModule/Top'
import Text from './textModule/Text'
import {observer, inject} from 'mobx-react'
import {reaction} from 'mobx'

@inject("uiState","appState")@observer
class App extends Component {
  modifyUIReaction;
  constructor(props){
    super(props)
  }
  componentDidMount(){
    this.modifyUIReaction = reaction(()=>this.props.appState.executeState,this.handleUIState)
  }
  handleUIState = ()=>{
    const state = this.props.appState.executeState
    if(state === Const.executeKey.not){
      this.props.uiState.beNotUI()
    }
    else if (state === Const.executeKey.doing) {
      this.props.uiState.beDoingUI()
    }
    else if (state === Const.executeKey.success) {
      this.props.uiState.beSuccessUI()
    }
    else if (state === Const.executeKey.warning) {
      this.props.uiState.beWarningUI()
    }
    else if (state === Const.executeKey.error) {
      this.props.uiState.beErrorUI()
    }
    else{

    }
  }
  render() {
    return <div>
      <Top></Top>
      <Text></Text>
    </div>
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js